// Zalogowana trasa Rozliczenia („Tokeny i plan”). Klucze zsynchronizowane z en/appBilling.ts.
// Dane pieniężne/ceny/pule/dni retencji żyją w API i przychodzą do komponentu — nigdy
// nie są wpisane w locale. Waluta UI = "tokeny" (reguła 34, runda B-R3, 20.09);
// nazwy pól API i kluczy (`gem_costs`, `gems`) to adresy techniczne i zostają.
//
// 0018 (projekt 02, stany 3–7 i 12): copy z `design/claude-design-wyniki/02-storefront-billing/copy/`
// 1:1. Rozliczenia NIE powtarzają katalogu (decyzja PM 1): plany i pakiety są w cenniku,
// tu jest saldo, „na co poszły”, plan, faktury i JEDNA główna akcja zależna od stanu.
export const appBilling = {
  title: 'Tokeny i plan',
  subtitle: 'Saldo, plan i płatności.',
  details: {
    balance: 'Skąd są tokeny i kiedy wygasają',
    plan: 'Limity i przechowywanie',
  },
  state: {
    loading: 'Wczytuję stan konta…',
    // Błąd całego ekranu (02c): zdanie + kod `billing-<status>` obok drogi naprawy.
    errorTitle: 'Nie udało się wczytać salda i planu.',
    retry: 'Spróbuj ponownie',
  },
  invStatus: {
    paid: 'opłacona',
    pending: 'oczekuje',
    failed: 'nieudana',
    refunded: 'zwrócona',
  },
  // Nagłówek salda: „12 = 4 edity · edit kosztuje 3 gemy”. `edits` i `gems` przychodzą
  // JUŻ odmienione i sformatowane (editWord / gemWord), policzone z ceny z serwera
  // (lib/gems.ts). Bez ceny zostaje sama liczba gemów — lepiej nic niż zmyślona liczba.
  hero: {
    equals: '= {edits} · edit kosztuje {gems}',
  },
  plan: {
    heading: 'Twój plan',
    // Tytuł karty planu na ekranie: „Plan Starter”.
    headingNamed: 'Plan {name}',
    statusRow: 'Status',
    // Krótszy wariant `accessUntil` — wiersz karty niesie etykietę, nie zdanie.
    accessUntilShort: 'Dostęp do',
    label: 'Plan',
    noPlan: 'Bez planu',
    whatPlanGives: 'Co daje plan',
    whatPlanGivesBody: 'pula gemów co miesiąc + dostęp do publikacji',
    // Zdanie z linkiem w środku: [pre][link][post].
    catalogNotePre: 'Plany i pakiety są w ',
    catalogLink: 'Zobacz plany i pakiety',
    catalogNotePost: ' - tu jest tylko Twoje konto.',
    perMonth: '/ mies.',
    // Sesja 11 (artboard 10): cena w osobnym wierszu; sloty linkują do „Twoich kont” z sesji 12 (decyzja 10).
    price: 'Cena',
    accountsLink: 'Twoje konta',
    statusActive: 'aktywny',
    statusCancelled: 'anulowany',
    nextCharge: 'Następne obciążenie',
    accessUntil: 'Dostęp i gemy z planu do',
    slots: 'Konta do publikacji',
    // `unit` odmienione w komponencie (slotsUnit_*): „1 / 2 sloty”, „2 / 8 slotów”.
    slotsOf: '{used} / {total} {unit}',
    slotsUnit_one: 'slot',
    slotsUnit_few: 'sloty',
    slotsUnit_many: 'slotów',
    storage: 'Miejsce na materiały',
    storageOf: '{used} / {total} GB',
    readyEdits: 'Gotowe edity',
    readyEditsValue: 'do pobrania {days} dni od powstania pliku',
    uploads: 'Utwory i własne klipy',
    // Bez zegara (Domi, 2026-09-15): materiał użytkownika nie znika sam z siebie.
    uploadsValue: 'zostają na Twoim koncie',
    boughtGems: 'Dokupione gemy',
    boughtGemsValue: 'zostają do końca swojego terminu',
  },
  storage: {
    // Jedyne miejsce, w którym żyje obietnica retencji renderów; {days} z API (`retention.render_days`).
    retention: 'Gotowe edity możesz pobierać przez {days} dni od powstania pliku.',
  },
  cancel: {
    body: 'Anulujesz w portalu klienta („Zarządzaj metodą płatności” → „Anuluj subskrypcję”), bez pisania do nas. Dostęp i gemy z planu zostają do końca opłaconego okresu.',
  },
  invoice: {
    subscription: 'subskrypcja',
    topup: 'tokeny',
  },
  notice: {
    successPlanTitle: 'Płatność przyjęta - plan {name} aktywny.',
    successTopupTitle: 'Płatność przyjęta - tokeny są już na koncie.',
    successConfirmed: 'Przydział {gems} potwierdziliśmy w historii konta. Saldo i faktury poniżej są aktualne.',
    pendingTitle: 'Płatność czeka na potwierdzenie',
    checkingSub: 'Sprawdzamy płatność i przydział gemów. Nie płać drugi raz.',
    pendingSub: 'Stripe odesłał Cię do EDIMI, ale webhook z przydziałem gemów jeszcze nie dotarł. Nie płać drugi raz - sprawdź ponownie za chwilę.',
    unavailableTitle: 'Nie udało się jeszcze potwierdzić płatności',
    unavailableSub: 'Nie pokazujemy sukcesu, dopóki płatność i przydział gemów nie są potwierdzone po naszej stronie.',
    unverifiedTitle: 'Nie możemy powiązać tego powrotu z płatnością',
    // Trzy stany niepewne = pigułka w karcie salda, nie baner (decyzja 3).
    pendingPill: 'płatność czeka na potwierdzenie',
    unavailablePill: 'nie udało się potwierdzić płatności',
    unverifiedPill: 'powrót bez potwierdzenia płatności',
    unverifiedSub: 'Sam adres strony nie potwierdza zapłaty. Aktualne saldo i faktury widzisz poniżej.',
    checkAgain: 'Sprawdź ponownie',
    invoicePdf: 'Pobierz fakturę PDF',
    invoicePdfNamed: 'Pobierz {number} - PDF',
    cancelTitle: 'Płatność anulowana - konto bez zmian.',
    cancelSub: 'Checkout nie został ukończony, nic nie pobrano. Możesz wrócić do zamówienia i wybrać metodę płatności w Stripe.',
    backToOrder: 'Wróć do zamówienia',
    successTitle: 'Płatność przyjęta',
    successSub: 'Saldo konta zaktualizuje się za chwilę.',
    declinedTitle: 'Płatność odrzucona / anulowana',
    declinedSub: 'Transakcja nie została ukończona - Twoje konto pozostało bez zmian. Spróbuj ponownie lub wybierz inną metodę płatności.',
  },
  // MIERNIK DWÓCH KUBEŁKÓW. Gemy z planu i gemy dokupione mają RÓŻNE zasady wygasania,
  // więc jeden licznik salda kłamie. Rozbicie + kolejność zużycia są obowiązkowe.
  meter: {
    total: 'Twoje gemy',
    // Stan salda pigułką przy liczbie (decyzja 2); „niski stan” stoi w `dashboard.low`.
    pillZero: 'brak tokenów',
    fromPlan: 'Z planu',
    fromPlanOf: '{used} / {total}',
    renewsOn: 'Odnowi się {date}',
    choosePlan: 'Wybierz plan',
    // `count` = pula planu z API („+4 000 gemów”), nie stała.
    renewsOnPlus: 'Odnowi się {date} · +{count} gemów',
    accessUntil: 'Dostęp do {date}',
    purchased: 'Dokupione i bonus',
    purchasedNote: 'Dokupione ważne 24 miesiące od zakupu; bonus powitalny nie wygasa.',
    // Kolejność zużycia to zdanie o CUDZYCH pieniądzach: plan → dokupione (najbliższy
    // termin najpierw) → bonus bez terminu na koniec (`wallet/service.py`).
    spendOrder: 'Najpierw zużywamy gemy z planu, potem dokupione - od najbliższego terminu ważności; bonus powitalny idzie na koniec.',
    noPlanHint: 'Nie masz planu - masz tylko gemy dokupione i bonus startowy.',
  },
  // JEDNA główna akcja zależna od stanu (decyzja PM 1): bez planu → „Wybierz plan”;
  // aktywny → „Doładuj”; niski/0 → „Doładuj” + „Zmień plan”; anulowany → „Wznów”.
  actions: {
    topup: 'Doładuj tokeny',
    // Akcja nagłówka i link przy saldzie w powłoce — jedno słowo, bez dopełnienia.
    topupShort: 'Doładuj',
    resumeShort: 'Wznów',
    changePlan: 'Zmień plan',
    resume: 'Wznów plan {name}',
    contact: 'Napisz do nas',
    manage: 'Zarządzaj metodą płatności',
    // Przy GATE 3 przyciski są WYŁĄCZONE, nie ukryte — to zdanie mówi czytnikowi ekranu dlaczego.
    disabledHint: 'Płatności są chwilowo wyłączone po naszej stronie.',
  },
  // Stany salda — banery między kubełkami a akcjami.
  // Reguła 35 zabrała stąd dwa zdania: `rule` („Niski stan zaczyna się poniżej…”)
  // i `renewal` („Odnowienie … doda …”). Próg pokazuje KOLOR liczby salda i pigułka
  // przy niej, a datę odnowienia niesie jedna linia mono w karcie planu —
  // tłumaczenie kontrolki, na którą czytelnik właśnie patrzy, to dokładnie to,
  // czego zakazuje zasada 8.
  low: {
    // `gems`/`edits` odmienione: „7 gemów = 2 edity”.
    title: 'Niski stan: {gems} = {edits}.',
    noPlan: 'Pomoże dokup pakietu albo plan z pulą gemów co miesiąc.',
  },
  zero: {
    title: '0 gemów = 0 editów. Render nie ruszy.',
    body: 'Dwie drogi: dokup pakiet (gemy od razu, ważne 24 miesiące) albo wyższy plan od następnego okresu.',
    bodyNoPlan: 'Dwie drogi: dokup pakiet (gemy od razu, ważne 24 miesiące) albo plan z pulą gemów co miesiąc.',
    // TYLKO gdy ledger potwierdza zwroty w tym okresie ({gems} odmienione: „14 gemów”).
    refunded: 'Nieudane rendery nie kosztowały - zwrócone automatycznie: {gems}.',
  },
  cancelled: {
    title: 'Plan {name} anulowany. Dostęp do {date}.',
    // Jeden zegar (decyzja PM 6, zwężona 2026-09-15): liczba dni z API
    // (`retention.render_days`), nie stała w komponencie. Utwory i klipy nie mają
    // zegara - zostają na koncie (Domi: dodane assety użytkownika nie znikają).
    body: 'Do tej daty gemy z planu działają jak dotąd. Każdy gotowy edit możesz pobierać przez {renderDays} dni od jego powstania - ten zegar nie zależy od planu. Wgrane utwory i własne klipy zostają na Twoim koncie. Dokupione gemy zostają do końca swojego terminu.',
  },
  // GATE 3 jako STAN STRONY (decyzja PM 4), źródło: `plans.available` / `topups.available`.
  // Bez obietnicy maila ani terminu — nie ma mechanizmu, który by ją spełnił.
  gate3: {
    title: 'Zakupy są teraz niedostępne',
    body: 'Nic nie pobraliśmy. Obecne gemy i reszta konta działają normalnie.',
    // R3: gdy zamknięty jest tylko jeden katalog, zdanie mówi który — drugi przycisk działa.
    bodyPlans: 'Planu nie kupisz teraz. Pakiety i reszta konta działają normalnie.',
    bodyPacks: 'Pakietu nie kupisz teraz. Plany i reszta konta działają normalnie.',
  },
  // ZUŻYCIE (reguła 35) — moduł ze słupkami dzień po dniu w karcie salda.
  // Liczby idą z `token_ledger` (usage_breakdown()), nie z odejmowania salda.
  //
  // Co UMARŁO razem z oknem-listą „Ruch gemów”: `period` („w tym okresie”),
  // `summary`, `spent_render` / `spent_publish` / `spent_cut` (stawka po fakcie
  // tłumaczyła liczbę, którą czytelnik właśnie czyta — zasada 8) oraz
  // `sourceNote`. Zostały trzy nazwy warstw, dwie etykiety liczb i nazwa wykresu
  // dla czytnika ekranu.
  usage: {
    heading: 'Zużycie',
    spentLabel: 'Wykorzystano',
    refundedLabel: 'Zwrócono',
    render: 'Edity',
    publish: 'Publikacje',
    cut: 'Pocięcia',
    // Pozycje muzyki (runda 32-R5, `R5-13`): warstwa legendy jest JEDNA („muzyka”),
    // a dymek dnia rozbija ją na to, za co naprawdę zeszły tokeny.
    layerMusic: 'Muzyka',
    textAnalysis: 'Analiza tekstu',
    refundTextAnalysis: 'Zwrócono · analiza tekstu',
    // Pusty stan modułu: glif i tytuł, bez drugiego zdania (zasada 8, punkt 4).
    emptyTitle: 'Brak zużycia',
    // Nazwa obrazu i podpis tabeli danych — wykres jest obrazem, więc liczby dnia
    // muszą dać się przeczytać bez celowania w dziesięciopikselowy słupek.
    chartLabel: 'Zużycie tokenów dzień po dniu',
    dayColumn: 'Dzień',
  },
  payment: {
    manage: 'Zarządzaj metodą płatności',
    nextChargeLabel: 'Następne obciążenie:',
  },
  // FAKTURY: tylko istniejące wiersze (payments + invoices), PDF gdy jest.
  invoices: {
    heading: 'Płatności i faktury',
    loading: 'Wczytuję faktury…',
    empty: 'Brak płatności',
    // Bez strzałki w tekście - ikonę linku zewnętrznego rysuje komponent (G7-23).
    allInPortal: 'Wszystkie w portalu klienta',
    lineCount_one: '{count} pozycja',
    lineCount_few: '{count} pozycje',
    lineCount_many: '{count} pozycji',
    lineProration: '{plan} - proporcjonalnie od {date}',
    lineRefund: '{plan} - zwrot za niewykorzystany okres',
    lineSlots: 'Dokupione sloty: {count}',
    linePlan: 'Plan {plan} - {month}',
    renewal: 'Odnowienie subskrypcji',
    pdf: 'Pobierz PDF',
  },
}
